import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ValidateTicket from '../../pages/public/js/ValidateTicket';
import CancelEvent from '../../pages/public/js/CancelEvent';
import RedirectToExternal from '../RedirectToExternal';
import EventLinkGeneration from '../../pages/public/js/EventLinkGeneration';
const EventRoutes = () => (
  <Routes>
    <Route path="/validate-ticket" element={<ValidateTicket />} />
    <Route path="/cancel-booking" element={<CancelEvent />} />
    <Route path="/event-link-generation" element={<EventLinkGeneration />} />
    {/* Catch-all route for undefined paths */}
    <Route path="*" element={<RedirectToExternal url={`${process.env.REACT_APP_WEBSITE_BASE_URL}`} />} />
  </Routes>
);

export default EventRoutes;
